import { render } from "./ReportsMenu.vue?vue&type=template&id=c500a006&scoped=true"
import script from "./ReportsMenu.vue?vue&type=script&lang=js"
export * from "./ReportsMenu.vue?vue&type=script&lang=js"

import "./ReportsMenu.vue?vue&type=style&index=0&id=c500a006&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c500a006"]])

export default __exports__